import { request } from '../utils/request';

export const getLogstashStatus = params =>
  request.get(`/logstash/status`, { params });
export const stopLogstash = data => request.post(`/logstash/stop-all`, data);
export const runLogstash = data => request.post('/logstash/import', data);
